'use strict';

module.exports = {
  POSITIVE_INT_PATTERN: /^(0|[1-9]\d*)$/,
  INT_PATTERN: /^(0|(\-|)[1-9]\d*)$/,
  INT_PATTERN_IGNORE_LEAD_ZERO: /^((\-|)[0-9]\d*)$/,
  ALPHA_NUMERIC_WITH_SOME_EXTRA_CHARS: /^[a-zA-Z0-9 _<>=\-]+$/,
  FLOAT_PATTERN: /^(0|(\-|)(0|[1-9]\d*))(|\.\d+)$/,
  FLOAT_PERSISTENCE_2_PATTERN: /^(0|(\-|)(0|[1-9]\d*))(|\.\d{1,2})$/,
  FLOAT_PERSISTENCE_3_PATTERN: /^(0|(\-|)(0|[1-9]\d*))(|\.\d{1,3})$/,
  PERCENTAGE_PATTERN: /^(0|\d{0,2}(\.\d{1,2})?|100(\.00?)?)$/,
  POSITIVE_DOUBLE: /^(0|[1-9]\d*)(|\.\d+)$/,
  POSITIVE_FLOAT_PERSISTENCE_1_PATTERN: /^(0|[1-9]\d*)?(\.\d{1})?$/,
  POSITIVE_FLOAT_PERSISTENCE_2_PATTERN: /^(0|[1-9]\d*)?(\.\d{1,2})?$/,
  STRATEGY_ACTION_CLASS_LINK_VALUE_PATTERN: /^((\d+%)?[A-Z]((\+|-)(\d+))?)$/,
  DEFAULT_FARE_VALUE_PATTERN: /^((\d+(%[A-Z]((\+|-)(\d+))?)?)|([A-Z]((\+|-)(\d+))?))$/,
  BUDGET_TARGET_DESCRIPTION_VALUE_PATTERN: /^[a-zA-z0-9\s\*'-]*$/,
  VALID_MARKET_PATTERN: /^[A-Za-z0-9]{3,5}$/,
  COMMA_SEPARATED_CARRIER_CODE_PATTERN: /^[A-Za-z0-9]{2}(,[A-Za-z0-9]{2})*$/,
  COMMA_SEPARATED_AIRPORT_CODE_PATTERN: /^[A-Za-z]{3}(,[A-Za-z]{3})*$/,
  COMMA_SEPARATED_CABINS_PATTERN: /^[A-Z]{1}(,[A-Z]{1})*$/,
  COMMA_SEPARATED_RBD_PATTERN: /^[A-Za-z]{1}(,[A-Za-z]{1})*$/,
  COMMA_SEPARATED_COMPETITOR_RBD_PATTERN: /^[A-Z](,[A-Z])*$|^-$/,
  TIME_OF_DAY_PATTERN: /^(((?!0000)([0-1][0-9]|2[0-3])[0-5][0-9])|2400)*$/,
  COMMUNITY_PORTAL_COOKIE_NAME: 'iPlanetDirectoryPro',
  CARRIER_CODE_COOKIE_NAME: 'carrierCode',
  SEASONALITY_NAME_REGEX: /^[A-Za-z0-9 -]{6,50}$/
};